import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';

export const ArrowRight = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M40.7071 20.2929L34.3431 13.9289C33.9526 13.5384 33.3195 13.5384 32.9289 13.9289C32.5384 14.3194 32.5384 14.9526 32.9289 15.3431L37.5858 20H2C1.44772 20 1 20.4477 1 21C1 21.5523 1.44772 22 2 22H37.5858L32.9289 26.6568C32.5384 27.0474 32.5384 27.6805 32.9289 28.0711C33.3195 28.4616 33.9526 28.4616 34.3431 28.0711L40.7071 21.7071C41.0976 21.3166 41.0976 20.6834 40.7071 20.2929Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
		</svg>
	);
};
